import DatePicker from "components/foundation/DatePicker";
import DocumentTextField from "components/foundation/DocumentTextField/DocumentTextField";
import React, { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import CreateDocumentForm from "../../CreateDocumentForm";
import CreateDocumentClassFormBody from "../CreateDocumentClassFormBody";
import { TempDocumentDetailResponseWithAny } from "features/document/hooks/queries/useTempDocumentDetailQuery";
import { RECEIVE_OFFICIAL_LETTER_FIELD as FIELD } from "config/documentConstant";
import formatMinMaxLengthMessage from "utils/formatUtils/formatMinMaxLengthMessage";
import { useRecoilValue } from "recoil";
import { selectedWorkCompanyState } from "store/document/workDocument";

/* 공문 수신 */
interface ReceiveOfficialLetterForm {
  [FIELD.DOCUMENT_RECEIPT_NUMBER.key]: string;
  [FIELD.SENDER.key]: string;
  [FIELD.REGISTRATION_DATE.key]: string;
  [FIELD.TITLE.key]: string;
}

interface ReceiveOfficialLetterProps {
  tempDocumentDetail?: TempDocumentDetailResponseWithAny;
}

const ReceiveOfficialLetter = ({
  tempDocumentDetail,
}: ReceiveOfficialLetterProps) => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext<ReceiveOfficialLetterForm>();

  const company = useRecoilValue(selectedWorkCompanyState);

  useEffect(() => {
    setValue(FIELD.DOCUMENT_RECEIPT_NUMBER.key, company?.uuid || "");
  }, []);
  // 공문 수신번호를 생성하기 위한 공문 수신 번호 필드는 삭제되었지만 백앤드 로직은 똑같기 때문에 API req 필드에는 그대로 남겨둠

  return (
    <CreateDocumentClassFormBody noBorderTop>
      <CreateDocumentForm.Field label={FIELD.SENDER.label}>
        <DocumentTextField
          {...register(FIELD.SENDER.key, {
            required: "발신자 입력 필수",
            minLength: {
              value: FIELD.SENDER.minLength,
              message: formatMinMaxLengthMessage(
                FIELD.SENDER.minLength,
                FIELD.SENDER.maxLength,
              ),
            },
            maxLength: {
              value: FIELD.SENDER.maxLength,
              message: formatMinMaxLengthMessage(
                FIELD.SENDER.minLength,
                FIELD.SENDER.maxLength,
              ),
            },
          })}
          placeholder="발신자명을 입력해 주세요."
          errorMessage={errors[FIELD.SENDER.key]?.message}
        />
      </CreateDocumentForm.Field>

      <CreateDocumentForm.Field label={FIELD.REGISTRATION_DATE.label}>
        <Controller
          name={FIELD.REGISTRATION_DATE.key}
          control={control}
          rules={{
            required: "수신일 선택 필수",
          }}
          render={({ field }) => (
            <DatePicker
              {...field}
              usage="document"
              isTimePicker
              placeholder="수신일을 선택해 주세요."
              defaultValue={
                tempDocumentDetail?.documentData?.[FIELD.REGISTRATION_DATE.key]
              }
              dateFormat={FIELD.REGISTRATION_DATE.dateFormat}
              onChangeDate={(_, dateString) => {
                field.onChange(dateString);
              }}
              errorMessage={errors[FIELD.REGISTRATION_DATE.key]?.message}
            />
          )}
        />
      </CreateDocumentForm.Field>

      <CreateDocumentForm.Field label={FIELD.TITLE.label}>
        <DocumentTextField
          {...register(FIELD.TITLE.key, {
            required: "제목 입력 필수",
            minLength: {
              value: FIELD.TITLE.minLength,
              message: formatMinMaxLengthMessage(
                FIELD.TITLE.minLength,
                FIELD.TITLE.maxLength,
              ),
            },
            maxLength: {
              value: FIELD.TITLE.maxLength,
              message: formatMinMaxLengthMessage(
                FIELD.TITLE.minLength,
                FIELD.TITLE.maxLength,
              ),
            },
          })}
          placeholder="제목을 입력해 주세요."
          errorMessage={errors[FIELD.TITLE.key]?.message}
        />
      </CreateDocumentForm.Field>
    </CreateDocumentClassFormBody>
  );
};

export default ReceiveOfficialLetter;
